import { tracking } from '@iwoca/frontend-tracking-library';
import { Link } from '@iwoca/orion';
import { getCurrentPathname } from '@iwRouter/LocationHelper';

import DocumentRequirement from '../DocumentRequirement';
import { TGetProductOffersResponseData } from '../TradingHistory';

type TProps = {
    quantifier: number;
    isOptional: boolean;
    isSubmitted: boolean;
    status?: TGetProductOffersResponseData['products'][number]['data_requirements'][number]['status'];
};
const VATReturns = ({ quantifier, isOptional, status }: TProps) => {
    return (
        <DocumentRequirement
            title="VAT returns"
            documentType="vat return"
            isOptional={isOptional}
            status={status}
        >
            <>
                <p>
                    Your last {quantifier} months of VAT returns in PDF format.
                    These should include the nine box summary page for each
                    return. You don't need to include the detailed breakdowns
                    for each VAT return.{' '}
                    <Link
                        href="https://www.gov.uk/sign-in-vat-account"
                        target="_blank"
                        rel="noreferrer"
                        onClick={() =>
                            tracking.ampli.externalLinkClicked({
                                category: 'Optional document: VAT return',
                                'CTA destination': 'VAT return guide',
                                'CTA URL':
                                    'https://www.gov.uk/sign-in-vat-account',
                                'CTA text': 'Learn more',
                                'Page name': 'Application pending view',
                                URL: getCurrentPathname()
                            })
                        }
                    >
                        Learn more
                    </Link>
                </p>
            </>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default VATReturns;
